
import Vue from 'vue'
export default Vue.extend({
  props: {
    persistContents: {
      type: Boolean,
      default: false
    }
  },
  mounted(): void {
    document.querySelector('body')!.classList.add('is-locked')
  },
  destroyed(): void {
    document.querySelector('body')!.classList.remove('is-locked')
  },
  methods: {
    clickHandler(): void {
      if (this.persistContents) return
      this.$emit('clickOnSelf')
    }
  }
})
